module.exports = __webpack_public_path__ + "static/media/planta6.273a8c52.jpg";